<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="structure-next"><span><img alt="IllustrationContent-18.png" class="frame1" src="OEBPS/image/IllustrationContent-18_fmt.png"/></span><a id="_idTOCAnchor-1"></a> </p>
<p class="preface"> </p>
<p class="preface" id="calibre_toc_4"><a id="b2"></a><a href="#/OEBPS/NGJobHacks_split_004#a2">CHAPTER 1 // <br class="calibre2"/>I Got A Useless Degree…Now What?</a></p>
<div class="calibre1" id="calibre_pb_7"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NGJobHacks_split_007.vue?73be34dd